// helix-exception: Helix has no semantic token for these hues (Figma needs-input orange, highlight yellow/amber, categorical teal/cyan); primitive ramps with the identical colour are used (F-11)
import type { MouseEvent } from 'react'

interface ClinicalSummaryOrphanNoteProps {
  count: number
  disabled?: boolean
  onRemoveAll: (event: MouseEvent<HTMLButtonElement>) => void
  onKeep: (event: MouseEvent<HTMLButtonElement>) => void
}

const ACTION_CLASS =
  'cursor-pointer rounded-sm px-2 py-0.5 text-xs font-medium leading-5 text-orange-700 dark:text-orange-200 hover:bg-orange-500/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 disabled:cursor-not-allowed disabled:opacity-50'

/** Figma R11 / S05: terms still on the order whose supporting text is no longer in the summary. */
export function ClinicalSummaryOrphanNote({ count, disabled, onRemoveAll, onKeep }: ClinicalSummaryOrphanNoteProps) {
  if (count <= 0) return null

  return (
    <div
      className="flex items-center gap-2.5 rounded-base border border-orange-500 dark:border-orange-700 bg-warning-50 dark:bg-gray-900 px-3 py-2 text-sm leading-5 text-orange-700 dark:text-orange-200"
      role="note"
      data-testid="clinical-summary-orphan-note"
    >
      <p className="min-w-0 flex-1">
        {count === 1
          ? '1 phenotype is no longer in your summary but still on the order.'
          : `${count} phenotypes are no longer in your summary but still on the order.`}
      </p>
      <div className="flex shrink-0 items-center">
        <button type="button" className={ACTION_CLASS} disabled={disabled} onClick={onRemoveAll}>
          Remove all {count}
        </button>
        <button type="button" className={ACTION_CLASS} disabled={disabled} onClick={onKeep}>
          Keep
        </button>
      </div>
    </div>
  )
}
